export default __webpack_public_path__ + "static/media/IconBookInactive.7087aa14.svg";